const FIELDS_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  SELECT_OPTIONS: 'select options'
}
export default FIELDS_TYPES
